/**
 * 2nd Hearing Form — TOKYO WIG CREATE
 *
 * 6-section wizard:
 *   1. Your Information (prefilled)
 *   2. Character & References
 *   3. Wig Specifications  (color URL / hairline finish / face length)
 *   4. Head Measurements   (5 measurements + optional head-shape photos)
 *   5. Usage & Timeline
 *   6. Contact & Final Notes
 */
(function () {
  "use strict";

  // ═══════════════════════════════════════
  // Config
  // ═══════════════════════════════════════
  var CONFIG = {
    kintoneAppId: 5,
    gasWebAppUrl: "https://script.google.com/macros/s/AKfycbx5Vv2Ljvfbf3aEGrLORO1yVxrviCH5kQC6W9yWpLb2qWMvB_SSD2IRBEA1MNVn3WuVlg/exec",
    maxRefImages: 10,
    minRefImages: 2,
    maxHeadImages: 5,
    maxImageSize: 15 * 1024 * 1024, // 15MB pre-resize (iPhone Live Photos can be ~10MB)
    allowedTypes: ["image/jpeg", "image/png", "image/webp"],
    resizeMaxDim: 1920,        // 縮小後の長辺最大px
    resizeQuality: 0.85,       // JPEG再エンコード品質
    resizeOutputType: "image/jpeg",
    totalSections: 6,
    storageKey: "twc_hearing_draft_v2",
    shopifyOrigin: "https://tokyowigcreate.com",
    caseAccessTitle: "We couldn't verify this form link.",
    caseAccessBody: "Please return to the email we sent you and open the form from that link. If the issue continues, reply to that email and our concierge will help.",
    colorGroupHandles: [
      "yellow-gold-deep-gold",
      "purple-pink-red-orange",
      "brown-gray-brown-red-brown-yellow-brown",
      "blue-deep-blue-marine-blue-green",
      "black-gray-silver-white",
    ],
  };
  // 日本語訳・意図: "このフォームリンクを確認できませんでした。メール内のリンクから開き直し、続く場合はそのメールへ返信してください。"
  // 無効なcase_idで空フォームや別下書きを見せず、顧客を手動確認へ戻すための案内。

  // ═══════════════════════════════════════
  // State
  // ═══════════════════════════════════════
  var state = {
    currentSection: 1,
    refFiles: [],
    headFiles: [],
    caseIdFromUrl: "",
    caseLookupStatus: "missing",
  };

  // ═══════════════════════════════════════
  // Init
  // ═══════════════════════════════════════
  document.addEventListener("DOMContentLoaded", function () {
    prefillFromUrl();
    setupImageUploads();
    setupCharCount();
    setupFormSubmit();
    setupColorPicker();
    updateProgress();
  });

  // ═══════════════════════════════════════
  // URL Prefill
  // ═══════════════════════════════════════
  function prefillFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var caseId = params.get("case_id") || "";
    if (!caseId) {
      state.caseLookupStatus = "invalid";
      showCaseAccessError();
      return;
    }
    state.caseIdFromUrl = caseId;
    state.caseLookupStatus = "pending";
    document.getElementById("caseId").value = caseId;
    fetchRecordByCaseId(caseId);
  }

  function fetchRecordByCaseId(caseId) {
    gasGet({
      action: "searchRecords",
      app: CONFIG.kintoneAppId,
      query: 'case_id = "' + caseId + '"',
    })
      .then(function (result) {
        if (!result.success || !result.records || !result.records.length) {
          state.caseLookupStatus = "invalid";
          showCaseAccessError();
          return;
        }
        state.caseLookupStatus = "valid";
        hideCaseAccessError();
        var rec = result.records[0];
        applyPrefill("customerName", rec.customer_name);
        applyPrefill("customerEmail", rec.email);
        applyPrefill("characterName", rec.character_name);
        applyPrefill("seriesName", rec.series_name);
        restoreFromStorage();
      })
      .catch(function () {
        state.caseLookupStatus = "invalid";
        showCaseAccessError();
      });
  }

  function applyPrefill(elId, kintoneField) {
    if (!kintoneField) return;
    var el = document.getElementById(elId);
    if (el && !el.value) el.value = kintoneField.value || "";
  }

  function showCaseAccessError() {
    var form = document.getElementById("hearingForm");
    var progress = document.querySelector(".progress");
    var main = document.querySelector(".main");
    if (form) form.classList.add("hidden");
    if (progress) progress.classList.add("hidden");
    if (!main) return;

    var existing = document.getElementById("caseAccessMessage");
    if (!existing) {
      existing = document.createElement("section");
      existing.id = "caseAccessMessage";
      existing.className = "case-access-message";
      existing.setAttribute("role", "alert");
      main.insertBefore(existing, main.firstChild);
    }
    existing.innerHTML =
      '<h2 class="case-access-message__title">' + escapeHtml(CONFIG.caseAccessTitle) + "</h2>" +
      '<p class="case-access-message__body">' + escapeHtml(CONFIG.caseAccessBody) + "</p>";
  }

  function hideCaseAccessError() {
    var form = document.getElementById("hearingForm");
    var progress = document.querySelector(".progress");
    var existing = document.getElementById("caseAccessMessage");
    if (existing) existing.remove();
    if (form) form.classList.remove("hidden");
    if (progress) progress.classList.remove("hidden");
  }

  // ═══════════════════════════════════════
  // LocalStorage Auto-Save / Restore
  // ═══════════════════════════════════════
  function saveToStorage() {
    var form = document.getElementById("hearingForm");
    var data = {};
    for (var i = 0; i < form.elements.length; i++) {
      var el = form.elements[i];
      if (!el.name || el.type === "file") continue;
      if (el.type === "checkbox" && el.name !== "terms_agreed") {
        if (!data[el.name]) data[el.name] = [];
        if (el.checked) data[el.name].push(el.value);
      } else if (el.type === "checkbox") {
        data[el.name] = el.checked;
      } else if (el.type === "radio") {
        if (el.checked) data[el.name] = el.value;
      } else {
        data[el.name] = el.value;
      }
    }
    data._section = state.currentSection;
    try {
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(data));
    } catch (e) {
      // quota exceeded — ignore
    }
  }

  function restoreFromStorage() {
    var saved;
    try {
      saved = localStorage.getItem(CONFIG.storageKey);
    } catch (e) {
      return;
    }
    if (!saved) return;

    var data;
    try {
      data = JSON.parse(saved);
    } catch (e) {
      return;
    }
    if (state.caseIdFromUrl && data.case_id !== state.caseIdFromUrl) return;

    var form = document.getElementById("hearingForm");
    for (var i = 0; i < form.elements.length; i++) {
      var el = form.elements[i];
      if (!el.name || el.type === "file") continue;
      if (data[el.name] === undefined) continue;

      // Don't override prefilled identity fields
      if ((el.name === "case_id" || el.name === "customer_name" || el.name === "customer_email") && el.value) continue;

      if (el.type === "checkbox" && el.name !== "terms_agreed") {
        el.checked = Array.isArray(data[el.name]) && data[el.name].indexOf(el.value) !== -1;
      } else if (el.type === "checkbox") {
        el.checked = !!data[el.name];
      } else if (el.type === "radio") {
        el.checked = data[el.name] === el.value;
      } else {
        el.value = data[el.name];
      }
    }
  }

  // ═══════════════════════════════════════
  // Section Navigation
  // ═══════════════════════════════════════
  window.nextSection = function (current) {
    if (!validateSection(current)) return;
    saveToStorage();
    showSection(current + 1);
  };

  window.prevSection = function (current) {
    saveToStorage();
    showSection(current - 1);
  };

  function showSection(num) {
    for (var i = 1; i <= CONFIG.totalSections; i++) {
      var sec = document.getElementById("section" + i);
      if (sec) sec.classList.toggle("hidden", i !== num);
    }
    state.currentSection = num;
    updateProgress();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function updateProgress() {
    var pct = (state.currentSection / CONFIG.totalSections) * 100;
    document.getElementById("progressFill").style.width = pct + "%";
    document.getElementById("progressText").textContent =
      "Section " + state.currentSection + " of " + CONFIG.totalSections;
  }

  // ═══════════════════════════════════════
  // Validation
  // ═══════════════════════════════════════
  function validateSection(num) {
    var section = document.getElementById("section" + num);
    var valid = true;

    // Clear previous errors
    var errors = section.querySelectorAll(".field__error");
    for (var i = 0; i < errors.length; i++) errors[i].remove();
    var errorInputs = section.querySelectorAll(".error");
    for (var j = 0; j < errorInputs.length; j++) errorInputs[j].classList.remove("error");

    // Required text/email/url/select/textarea/number
    var inputs = section.querySelectorAll("input[required], textarea[required], select[required]");
    for (var k = 0; k < inputs.length; k++) {
      var input = inputs[k];
      if (input.type === "radio" || input.type === "checkbox") continue;
      if (!input.value || !String(input.value).trim()) {
        showFieldError(input, "This field is required.");
        valid = false;
      } else if (input.type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
        showFieldError(input, "Please enter a valid email address.");
        valid = false;
      } else if (input.type === "url" && !/^https?:\/\/.+/i.test(input.value)) {
        showFieldError(input, "Please enter a valid URL (starting with http:// or https://).");
        valid = false;
      }
    }

    // Required radio groups (one selection per group)
    var seenGroups = {};
    var requiredRadios = section.querySelectorAll('input[type="radio"][required]');
    for (var r = 0; r < requiredRadios.length; r++) {
      seenGroups[requiredRadios[r].name] = true;
    }
    Object.keys(seenGroups).forEach(function (name) {
      var checked = section.querySelector('input[name="' + name + '"]:checked');
      if (!checked) {
        var firstRadio = section.querySelector('input[name="' + name + '"]');
        if (firstRadio) {
          showGroupError(firstRadio.closest(".field"), "Please select an option.");
          valid = false;
        }
      }
    });

    // Section 2: at least minRefImages reference images
    if (num === 2 && state.refFiles.length < CONFIG.minRefImages) {
      var uploadField = document.getElementById("uploadArea");
      if (uploadField) {
        showGroupError(uploadField.closest(".field"),
          "Please upload at least " + CONFIG.minRefImages + " reference images.");
        valid = false;
      }
    }

    // Section 5: at least one usage_purpose
    if (num === 5) {
      var usageChecked = section.querySelectorAll('input[name="usage_purpose"]:checked');
      if (usageChecked.length === 0) {
        var usageField = section.querySelector('input[name="usage_purpose"]');
        if (usageField) {
          showGroupError(usageField.closest(".field"), "Please select at least one option.");
          valid = false;
        }
      }
    }

    // Section 6: terms agreement
    if (num === 6) {
      var terms = document.getElementById("termsAgreed");
      if (terms && !terms.checked) {
        showGroupError(terms.closest(".field"), "Please agree to the terms and conditions.");
        valid = false;
      }
    }

    return valid;
  }

  function showFieldError(input, msg) {
    input.classList.add("error");
    var err = document.createElement("p");
    err.className = "field__error";
    err.textContent = msg;
    input.parentNode.appendChild(err);
  }

  function showGroupError(fieldDiv, msg) {
    if (!fieldDiv) return;
    var err = document.createElement("p");
    err.className = "field__error";
    err.textContent = msg;
    fieldDiv.appendChild(err);
  }

  // ═══════════════════════════════════════
  // Character Count
  // ═══════════════════════════════════════
  function setupCharCount() {
    bindCount("charDescription", "charDescCount");
    bindCount("additionalNotes", "notesCount");
  }

  function bindCount(inputId, countId) {
    var inp = document.getElementById(inputId);
    var ctr = document.getElementById(countId);
    if (!inp || !ctr) return;
    inp.addEventListener("input", function () {
      ctr.textContent = this.value.length;
    });
  }

  // ═══════════════════════════════════════
  // Image Upload (reference + head shape)
  // ═══════════════════════════════════════
  function setupImageUploads() {
    bindUploadZone({
      dropzoneId: "dropzone",
      inputId: "fileInput",
      previewId: "previewArea",
      countId: "fileCount",
      bucket: "refFiles",
      max: CONFIG.maxRefImages,
      countLabel: "images",
    });
    bindUploadZone({
      dropzoneId: "headDropzone",
      inputId: "headFileInput",
      previewId: "headPreviewArea",
      countId: "headFileCount",
      bucket: "headFiles",
      max: CONFIG.maxHeadImages,
      countLabel: "photos",
    });
  }

  function bindUploadZone(opts) {
    var dropzone = document.getElementById(opts.dropzoneId);
    var fileInput = document.getElementById(opts.inputId);
    if (!dropzone || !fileInput) return;

    dropzone.addEventListener("dragover", function (e) {
      e.preventDefault();
      dropzone.classList.add("dragover");
    });
    dropzone.addEventListener("dragleave", function () {
      dropzone.classList.remove("dragover");
    });
    dropzone.addEventListener("drop", function (e) {
      e.preventDefault();
      dropzone.classList.remove("dragover");
      handleFiles(e.dataTransfer.files, opts);
    });

    fileInput.addEventListener("change", function () {
      handleFiles(this.files, opts);
      this.value = "";
    });
  }

  function handleFiles(fileList, opts) {
    var bucket = state[opts.bucket];
    var queue = [];
    for (var i = 0; i < fileList.length; i++) {
      var file = fileList[i];
      if (bucket.length + queue.length >= opts.max) {
        alert("Maximum " + opts.max + " " + opts.countLabel + " allowed.");
        break;
      }
      if (CONFIG.allowedTypes.indexOf(file.type) === -1) {
        alert(file.name + ": Invalid format. Use JPG, PNG, or WEBP.");
        continue;
      }
      if (file.size > CONFIG.maxImageSize) {
        alert(file.name + ": File too large. Maximum 15MB per file.");
        continue;
      }
      queue.push(file);
    }
    if (queue.length === 0) {
      renderPreviews(opts);
      return;
    }

    showResizingIndicator(opts, queue.length);
    Promise.all(queue.map(resizeImageFile)).then(function (resized) {
      resized.forEach(function (f) { bucket.push(f); });
      hideResizingIndicator(opts);
      renderPreviews(opts);
    }).catch(function (err) {
      hideResizingIndicator(opts);
      alert("Image processing failed: " + (err && err.message ? err.message : err));
      renderPreviews(opts);
    });
  }

  // Canvas を使って画像を long-edge resizeMaxDim 以内にリサイズ → JPEG 再エンコード
  function resizeImageFile(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var maxDim = CONFIG.resizeMaxDim;
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        var scale = 1;
        if (w > maxDim || h > maxDim) {
          scale = w >= h ? maxDim / w : maxDim / h;
        }
        var targetW = Math.round(w * scale);
        var targetH = Math.round(h * scale);

        var canvas = document.createElement("canvas");
        canvas.width = targetW;
        canvas.height = targetH;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, targetW, targetH);

        canvas.toBlob(function (blob) {
          URL.revokeObjectURL(url);
          if (!blob) {
            // fallback: original file (e.g. transparent PNG with alpha)
            resolve(file);
            return;
          }
          // 新しい File を作成（元のファイル名は保持、拡張子を .jpg に置換）
          var baseName = file.name.replace(/\.[^.]+$/, "");
          var resized = new File([blob], baseName + ".jpg", {
            type: CONFIG.resizeOutputType,
            lastModified: Date.now(),
          });
          // リサイズ後の方が元より大きい場合は元を使う（小さい画像での無駄を避ける）
          resolve(resized.size < file.size ? resized : file);
        }, CONFIG.resizeOutputType, CONFIG.resizeQuality);
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error("Could not decode " + file.name));
      };
      img.src = url;
    });
  }

  function showResizingIndicator(opts, count) {
    var fileCount = document.getElementById(opts.countId);
    if (fileCount) fileCount.textContent = "Processing " + count + " image(s)…";
  }
  function hideResizingIndicator(opts) {
    // renderPreviews が直後に呼ばれるので、ここでは何もしない
  }

  function renderPreviews(opts) {
    var previewArea = document.getElementById(opts.previewId);
    var fileCount = document.getElementById(opts.countId);
    var bucket = state[opts.bucket];
    previewArea.innerHTML = "";
    fileCount.textContent = bucket.length + " / " + opts.max + " " + opts.countLabel;

    bucket.forEach(function (file, idx) {
      var thumb = document.createElement("div");
      thumb.className = "upload__thumb";

      var img = document.createElement("img");
      img.src = URL.createObjectURL(file);
      img.alt = file.name;

      var removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "upload__thumb-remove";
      removeBtn.textContent = "×";
      removeBtn.setAttribute("data-index", idx);
      removeBtn.addEventListener("click", function () {
        var index = parseInt(this.getAttribute("data-index"), 10);
        bucket.splice(index, 1);
        renderPreviews(opts);
      });

      thumb.appendChild(img);
      thumb.appendChild(removeBtn);
      previewArea.appendChild(thumb);
    });
  }

  // ═══════════════════════════════════════
  // Color Picker (2-step: group → product)
  // ═══════════════════════════════════════
  function setupColorPicker() {
    loadColorGroups();
    var backBtn = document.getElementById("colorBackBtn");
    if (backBtn) backBtn.addEventListener("click", showGroupView);
    var changeBtn = document.getElementById("colorChangeBtn");
    if (changeBtn) changeBtn.addEventListener("click", showGroupView);

    // Modal close handlers
    var closeBtn = document.getElementById("modalCloseBtn");
    var overlay = document.getElementById("modalOverlay");
    if (closeBtn) closeBtn.addEventListener("click", closeColorModal);
    if (overlay) overlay.addEventListener("click", closeColorModal);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeColorModal();
    });

    // Restore selected color from localStorage if present
    var hidden = document.getElementById("colorUrl");
    if (hidden && hidden.value) {
      var saved = readSavedColorMeta();
      if (saved) showSelectedView(saved.url, saved.title, saved.imgSrc);
    }
  }

  // Shopify CDN URL を WebP + 指定幅にリサイズして取得
  function shopifyImg(src, width) {
    if (!src) return "";
    if (!/cdn\.shopify\.com/.test(src)) return src;
    var sep = src.indexOf("?") === -1 ? "?" : "&";
    return src + sep + "width=" + width + "&format=webp";
  }

  function loadColorGroups() {
    var container = document.getElementById("colorGroups");
    if (!container) return;

    fetch(CONFIG.shopifyOrigin + "/collections.json?limit=50")
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var byHandle = {};
        (data.collections || []).forEach(function (c) {
          byHandle[c.handle] = c;
        });
        var groups = CONFIG.colorGroupHandles
          .map(function (h) { return byHandle[h]; })
          .filter(Boolean);

        if (groups.length === 0) {
          container.innerHTML = '<p class="color-picker__error">Failed to load colors. Please refresh the page.</p>';
          return;
        }

        container.innerHTML = "";
        groups.forEach(function (g) {
          var tile = document.createElement("button");
          tile.type = "button";
          tile.className = "color-picker__tile color-picker__tile--group";
          tile.setAttribute("data-handle", g.handle);
          var groupImg = g.image && g.image.src ? shopifyImg(g.image.src, 320) : "";
          tile.innerHTML =
            '<div class="color-picker__tile-img-wrap">' +
              (groupImg
                ? '<img src="' + escapeAttr(groupImg) + '" alt="" class="color-picker__tile-img" loading="lazy">'
                : '<div class="color-picker__tile-img color-picker__tile-img--empty"></div>') +
            '</div>' +
            '<p class="color-picker__tile-title">' + escapeHtml(g.title) + '</p>';
          tile.addEventListener("click", function () {
            loadProductsForGroup(g);
          });
          container.appendChild(tile);
        });
      })
      .catch(function () {
        container.innerHTML = '<p class="color-picker__error">Failed to load colors. Please refresh the page.</p>';
      });
  }

  function loadProductsForGroup(group) {
    var groupView = document.getElementById("colorGroups");
    var productView = document.getElementById("colorProducts");
    var titleEl = document.getElementById("colorProductsTitle");
    var grid = document.getElementById("colorProductsGrid");
    if (!groupView || !productView || !grid) return;

    titleEl.textContent = group.title;
    grid.innerHTML = '<p class="color-picker__loading">Loading shades…</p>';
    groupView.classList.add("hidden");
    productView.classList.remove("hidden");
    productView.scrollIntoView({ behavior: "smooth", block: "start" });

    fetch(CONFIG.shopifyOrigin + "/collections/" + encodeURIComponent(group.handle) + "/products.json?limit=250")
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = data.products || [];
        if (products.length === 0) {
          grid.innerHTML = '<p class="color-picker__error">No products in this group yet.</p>';
          return;
        }
        grid.innerHTML = "";
        products.forEach(function (p) {
          var url = CONFIG.shopifyOrigin + "/products/" + p.handle;
          var firstImgSrc = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : "";
          var thumbSrc = shopifyImg(firstImgSrc, 280);
          var tile = document.createElement("button");
          tile.type = "button";
          tile.className = "color-picker__tile color-picker__tile--product";
          tile.setAttribute("data-url", url);
          tile.innerHTML =
            '<div class="color-picker__tile-img-wrap">' +
              (thumbSrc
                ? '<img src="' + escapeAttr(thumbSrc) + '" alt="" class="color-picker__tile-img" loading="lazy">'
                : '<div class="color-picker__tile-img color-picker__tile-img--empty"></div>') +
            '</div>' +
            '<p class="color-picker__tile-title">' + escapeHtml(p.title) + '</p>';
          tile.addEventListener("click", function () {
            openColorModal(p, url);
          });
          grid.appendChild(tile);
        });
      })
      .catch(function () {
        grid.innerHTML = '<p class="color-picker__error">Failed to load shades. Please try another group.</p>';
      });
  }

  function openColorModal(product, url) {
    var modal = document.getElementById("colorDetailModal");
    var titleEl = document.getElementById("modalTitle");
    var mainImg = document.getElementById("modalMainImg");
    var thumbs = document.getElementById("modalThumbs");
    var desc = document.getElementById("modalDescription");
    var selectBtn = document.getElementById("modalSelectBtn");
    if (!modal) return;

    titleEl.textContent = product.title;

    // Image gallery
    thumbs.innerHTML = "";
    var images = (product.images || []).filter(function (im) { return im && im.src; });

    function loadMain(src) {
      mainImg.classList.add("modal__main-img--loading");
      mainImg.onload = function () {
        mainImg.classList.remove("modal__main-img--loading");
      };
      mainImg.src = shopifyImg(src, 480);
    }

    if (images.length > 0) {
      mainImg.style.display = "";
      mainImg.alt = product.title;
      loadMain(images[0].src);
      if (images.length > 1) {
        images.forEach(function (im, i) {
          var t = document.createElement("button");
          t.type = "button";
          t.className = "modal__thumb" + (i === 0 ? " modal__thumb--active" : "");
          t.innerHTML = '<img src="' + escapeAttr(shopifyImg(im.src, 96)) + '" alt="" loading="lazy" decoding="async">';
          t.addEventListener("click", function () {
            loadMain(im.src);
            thumbs.querySelectorAll(".modal__thumb").forEach(function (th) {
              th.classList.remove("modal__thumb--active");
            });
            t.classList.add("modal__thumb--active");
          });
          thumbs.appendChild(t);
        });
      }
    } else {
      mainImg.style.display = "none";
    }

    // Description (Shopify body_html — sanitize lightly)
    var html = product.body_html || "";
    if (html.trim()) {
      desc.innerHTML = sanitizeHtml(html);
    } else {
      desc.innerHTML = '<p class="modal__description-empty">No description available.</p>';
    }

    // Select button
    var firstImg = images[0] ? images[0].src : "";
    selectBtn.onclick = function () {
      selectProduct(url, product.title, shopifyImg(firstImg, 200));
      closeColorModal();
    };

    modal.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  }

  function closeColorModal() {
    var modal = document.getElementById("colorDetailModal");
    if (!modal) return;
    modal.classList.add("hidden");
    document.body.style.overflow = "";
  }

  // Strip script/style/event-handler attributes and force lazy/resized images
  function sanitizeHtml(html) {
    var temp = document.createElement("div");
    temp.innerHTML = html;
    var unsafeTags = temp.querySelectorAll("script, style, iframe, object, embed");
    unsafeTags.forEach(function (n) { n.remove(); });
    var all = temp.querySelectorAll("*");
    all.forEach(function (el) {
      Array.from(el.attributes).forEach(function (attr) {
        if (/^on/i.test(attr.name)) el.removeAttribute(attr.name);
        if (attr.name === "href" && /^javascript:/i.test(attr.value)) el.removeAttribute(attr.name);
      });
    });
    // Resize embedded images to keep description light
    var imgs = temp.querySelectorAll("img");
    imgs.forEach(function (img) {
      var src = img.getAttribute("src");
      if (src) img.setAttribute("src", shopifyImg(src, 360));
      img.setAttribute("loading", "lazy");
      img.setAttribute("decoding", "async");
    });
    return temp.innerHTML;
  }

  function selectProduct(url, title, imgSrc) {
    var hidden = document.getElementById("colorUrl");
    if (hidden) hidden.value = url;
    writeSavedColorMeta({ url: url, title: title, imgSrc: imgSrc });
    showSelectedView(url, title, imgSrc);
    saveToStorage();
  }

  function showSelectedView(url, title, imgSrc) {
    document.getElementById("colorGroups").classList.add("hidden");
    document.getElementById("colorProducts").classList.add("hidden");
    var selected = document.getElementById("colorSelectedView");
    selected.classList.remove("hidden");
    document.getElementById("colorSelectedName").textContent = title || url;
    var img = document.getElementById("colorSelectedImg");
    if (imgSrc) {
      img.src = imgSrc;
      img.style.display = "";
    } else {
      img.style.display = "none";
    }
    // Clear any error state on the field
    var hiddenInput = document.getElementById("colorUrl");
    if (hiddenInput) {
      var fieldDiv = hiddenInput.closest(".field");
      if (fieldDiv) {
        var errs = fieldDiv.querySelectorAll(".field__error");
        errs.forEach(function (e) { e.remove(); });
      }
    }
  }

  function showGroupView() {
    document.getElementById("colorSelectedView").classList.add("hidden");
    document.getElementById("colorProducts").classList.add("hidden");
    document.getElementById("colorGroups").classList.remove("hidden");
  }

  function readSavedColorMeta() {
    try {
      var raw = localStorage.getItem(CONFIG.storageKey + "_color");
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function writeSavedColorMeta(meta) {
    try {
      localStorage.setItem(CONFIG.storageKey + "_color", JSON.stringify(meta));
    } catch (e) {
      // ignore
    }
  }

  function escapeHtml(str) {
    if (str == null) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }
  function escapeAttr(str) { return escapeHtml(str); }

  // ═══════════════════════════════════════
  // Form Submit
  // ═══════════════════════════════════════
  function setupFormSubmit() {
    var form = document.getElementById("hearingForm");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (state.caseLookupStatus !== "valid") {
        showCaseAccessError();
        return;
      }
      if (!validateSection(6)) return;
      submitForm();
    });
  }

  function submitForm() {
    var btn = document.getElementById("submitBtn");
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner"></span>Submitting...';

    var formData = collectFormData();

    // Upload reference images first, then head photos, then update record
    uploadFileBucket(state.refFiles, formData.case_id, "reference_images", function (refKeys) {
      uploadFileBucket(state.headFiles, formData.case_id, "head_photos", function (headKeys) {
        updateKintoneRecord(formData, refKeys, headKeys);
      }, function (err) {
        handleSubmitError("Head photo upload failed: " + err);
      });
    }, function (err) {
      handleSubmitError("Reference image upload failed: " + err);
    });
  }

  function collectFormData() {
    var form = document.getElementById("hearingForm");
    var data = {};

    var textFields = [
      "case_id", "customer_name", "customer_email",
      "character_name", "series_name", "character_description", "reference_urls",
      "color_url",
      "head_size", "head_to_hairline", "head_to_eyes", "head_to_ear", "head_to_nose",
      "head_shape_notes",
      "hard_deadline", "whatsapp_number", "additional_notes",
    ];
    textFields.forEach(function (name) {
      var el = form.elements[name];
      if (el) data[name] = el.value || "";
    });

    var radioFields = ["hairline_finish", "face_length"];
    radioFields.forEach(function (name) {
      var checked = form.querySelector('input[name="' + name + '"]:checked');
      data[name] = checked ? checked.value : "";
    });

    var checkboxFields = ["usage_purpose"];
    checkboxFields.forEach(function (name) {
      var checked = form.querySelectorAll('input[name="' + name + '"]:checked');
      var values = [];
      for (var i = 0; i < checked.length; i++) values.push(checked[i].value);
      data[name] = values;
    });

    data.terms_agreed = document.getElementById("termsAgreed").checked;
    return data;
  }

  // ═══════════════════════════════════════
  // GAS Proxy API
  // ═══════════════════════════════════════
  function gasGet(payload) {
    var url = CONFIG.gasWebAppUrl +
      "?payload=" + encodeURIComponent(JSON.stringify(payload));
    return fetch(url, { redirect: "follow" })
      .then(function (response) { return response.text(); })
      .then(function (text) { return JSON.parse(text); });
  }

  function gasPost(payload) {
    return new Promise(function (resolve, reject) {
      try {
        var reqId = "req_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8);
        payload.requestId = reqId;
        var bodyJson = JSON.stringify(payload);

        fetch(CONFIG.gasWebAppUrl, {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "text/plain;charset=UTF-8" },
          body: bodyJson,
        }).catch(function () {
          // no-cors errors are expected; the request itself is delivered
        });

        var attempts = 0;
        var maxAttempts = 40; // 40 × 3s = up to 120s

        function poll() {
          attempts++;
          if (attempts > maxAttempts) {
            reject(new Error("Timeout: GAS did not respond after 120s. reqId=" + reqId));
            return;
          }
          gasGet({ action: "checkResult", requestId: reqId })
            .then(function (res) {
              if (res.ready) resolve(res.result);
              else setTimeout(poll, 3000);
            })
            .catch(function () { setTimeout(poll, 3000); });
        }

        setTimeout(poll, 5000);
      } catch (initErr) {
        reject(new Error("gasPost init error: " + initErr.message));
      }
    });
  }

  function uploadFileBucket(files, caseId, bucket, onSuccess, onError) {
    if (!files || files.length === 0) {
      onSuccess([]);
      return;
    }

    var fileKeys = [];
    var pending = files.length;
    var hadFatal = false;

    files.forEach(function (file) {
      var reader = new FileReader();
      reader.onload = function () {
        var base64 = reader.result.split(",")[1];

        gasPost({
          action: "uploadFile",
          fileName: file.name,
          mimeType: file.type,
          fileData: base64,
          case_id: caseId,
          bucket: bucket,
        })
          .then(function (result) {
            if (result && result.success && result.fileKey) {
              fileKeys.push({ fileKey: result.fileKey });
            }
            pending--;
            if (pending === 0) {
              if (fileKeys.length > 0) onSuccess(fileKeys);
              else if (!hadFatal) onError("Upload failed. Please try again.");
            }
          })
          .catch(function (err) {
            pending--;
            if (pending === 0) {
              if (fileKeys.length > 0) onSuccess(fileKeys);
              else onError(err && err.message ? err.message : "Unknown upload error");
            }
          });
      };
      reader.onerror = function () {
        pending--;
        hadFatal = true;
        if (pending === 0) {
          if (fileKeys.length > 0) onSuccess(fileKeys);
          else onError("Failed to read file");
        }
      };
      reader.readAsDataURL(file);
    });
  }

  function updateKintoneRecord(data, refKeys, headKeys) {
    gasGet({
      action: "searchRecords",
      app: CONFIG.kintoneAppId,
      query: 'case_id = "' + data.case_id + '"',
    })
      .then(function (result) {
        if (result.success && result.records && result.records.length > 0) {
          var recordId = result.records[0].$id.value;
          putRecord(recordId, data, refKeys, headKeys);
        } else {
          handleSubmitError("Case ID not found: " + data.case_id);
        }
      })
      .catch(function (err) {
        handleSubmitError("Search error: " + (err.message || err));
      });
  }

  function putRecord(recordId, data, refKeys, headKeys) {
    var record = {
      status: { value: "2次ヒアリング受領" },
      pre_production_form_link_status: { value: "submitted" },
      pre_production_form_submitted_at: { value: new Date().toISOString() },
      character_name: { value: data.character_name },
      series_name: { value: data.series_name },
      character_description: { value: data.character_description },
      reference_urls: { value: data.reference_urls },
      color_url: { value: data.color_url },
      hairline_finish: { value: data.hairline_finish },
      face_length: { value: data.face_length },
      head_shape_notes: { value: data.head_shape_notes },
      usage_purpose: { value: data.usage_purpose },
      additional_notes: { value: data.additional_notes },
      terms_agreed: { value: data.terms_agreed ? "TRUE" : "FALSE" },
    };

    // Optional numeric measurements — only set if provided
    if (data.head_size) record.head_size = { value: data.head_size };
    if (data.head_to_hairline) record.head_to_hairline = { value: data.head_to_hairline };
    if (data.head_to_eyes) record.head_to_eyes = { value: data.head_to_eyes };
    if (data.head_to_ear) record.head_to_ear = { value: data.head_to_ear };
    if (data.head_to_nose) record.head_to_nose = { value: data.head_to_nose };

    if (data.hard_deadline) record.hard_deadline = { value: data.hard_deadline };
    if (data.whatsapp_number) record.whatsapp_number = { value: data.whatsapp_number };

    if (refKeys && refKeys.length > 0) {
      record.reference_images = { value: refKeys };
    }
    if (headKeys && headKeys.length > 0) {
      record.head_photos = { value: headKeys };
    }

    gasGet({
      action: "updateRecord",
      app: CONFIG.kintoneAppId,
      id: recordId,
      record: record,
    })
      .then(function (result) {
        if (result.success) {
          handleSubmitSuccess();
        } else {
          var errMsg = "Update failed: " + (result.error || "unknown");
          if (result.detail) errMsg += "\n\nDetail: " + result.detail;
          handleSubmitError(errMsg);
        }
      })
      .catch(function () {
        handleSubmitError("Network error during update");
      });
  }

  function handleSubmitSuccess() {
    try { localStorage.removeItem(CONFIG.storageKey); } catch (e) { /* noop */ }
    try { localStorage.removeItem(CONFIG.storageKey + "_color"); } catch (e) { /* noop */ }

    document.getElementById("hearingForm").classList.add("hidden");
    document.querySelector(".progress").classList.add("hidden");
    var successScreen = document.getElementById("successScreen");
    successScreen.classList.remove("hidden");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function handleSubmitError(msg) {
    alert("Submission error: " + msg + "\n\nYour data has been saved locally. Please try again.");
    var btn = document.getElementById("submitBtn");
    btn.disabled = false;
    btn.textContent = "Submit Request";
    saveToStorage();
  }
})();
